<template>
  <agent-detail :is-edit='true'>
  </agent-detail>
</template>

<script>
import AgentDetail from './components/AgentDetail'

export default {
  name: 'EditAgent',
  components: {
    AgentDetail
  }
}
</script>

